import {
  MaxGracePeriodForTwelveMonthsTerm,
  QuoteModality
} from 'src/utils/constants/quotes';
import * as Yup from 'yup';

export default (parameter, modality) => {
  return Yup.object().shape({
    equipmentInsuranceIncluded: Yup.boolean().required(
      'SCHEMA_ERRORS.REQUIRED_FIELD'
    ),
    totalPriceWithIva: Yup.number().required('SCHEMA_ERRORS.PRICE_REQUIRED'),
    gracePeriod: Yup.number()
      .when('term', {
        is: 12,
        then: schema =>
          schema.lessThan(
            MaxGracePeriodForTwelveMonthsTerm,
            'SCHEMA_ERRORS.GRACE_PERIOD_MUST_BE_LESS_THAN_SIXTY'
          )
      })
      .required('SCHEMA_ERRORS.VALUE_REQUIRED'),
    initialPayment: Yup.number().when(modality, {
      is: QuoteModality.FIRST_UPFRONT_RENT,
      then: schema => schema.optional(),
      otherwise: schema => schema.required('SCHEMA_ERRORS.VALUE_REQUIRED')
    }),
    selectedTerms: Yup.array().when([], {
      is: () => modality === QuoteModality.MSI,
      then: schema =>
        schema.min(1, 'SCHEMA_ERRORS.SELECT_AT_LEAST_ONE_MSI_TERM'),
      otherwise: schema => schema.optional()
    }),
    residualPayment: Yup.number().when('enableResidualValue', {
      is: true,
      then: schema =>
        schema.required('SCHEMA_ERRORS.REQUIRED_FIELD').test(
          'residual-payment-validation',
          'SCHEMA_ERRORS.RESIDUAL_PAYMENT_EXCEEDS_LIMIT',
          // eslint-disable-next-line func-names, consistent-return
          function(value) {
            if (!value || value === 0) {
              return this.createError({
                message: 'SCHEMA_ERRORS.MINIMUM_REQUIRED_RESIDUAL_PAYMENT'
              });
            }
            if (parameter && value) {
              const { totalPriceWithIva } = this.parent;
              if (Number(parameter.maxResidualValue) === 0 && value === 1) {
                return true;
              }
              const maxValue =
                (totalPriceWithIva * Number(parameter.maxResidualValue)) / 100;
              if (value > maxValue) {
                return this.createError({
                  message: 'SCHEMA_ERRORS.RESIDUAL_PAYMENT_EXCEEDS_LIMIT'
                });
              }
              return value > 0 && value <= maxValue;
            }
            return true;
          }
        ),
      otherwise: schema => schema.optional()
    })
  });
};
